import React from 'react';
import PropTypes from 'prop-types';
import { FONT, COLOURS, SHADOW } from '../../constants/theme';

/**
 * Dialog — RPG-style dialog box with an inner inset border.
 *
 * Renders a speaker-name badge above the dialog body text.
 * Accepts any React children as the dialog body (text + inline elements).
 *
 * @param {object}    props
 * @param {string}    props.name     - Speaker name shown in the badge.
 * @param {React.ReactNode} props.children - Dialog body content.
 */
function Dialog({ name, children }) {
  return (
    <div
      role="note"
      aria-label={`Dialog from ${name}`}
      style={{
        background:   COLOURS.cream,
        border:       `4px solid ${COLOURS.borderAmber}`,
        boxShadow:    SHADOW.dialog,
        padding:      '12px 14px',
        position:     'relative',
        fontFamily:   FONT,
      }}
    >
      {/* Inner decorative inset border — pure cosmetic */}
      <div
        aria-hidden="true"
        style={{
          position:      'absolute',
          top: 4, left: 4, right: 4, bottom: 4,
          border:        `1px solid ${COLOURS.primaryPale}`,
          pointerEvents: 'none',
        }}
      />

      {/* Speaker badge */}
      <div
        style={{
          fontSize:     7,
          color:        COLOURS.primary,
          border:       `2px solid ${COLOURS.borderAmber}`,
          background:   COLOURS.creamDark,
          display:      'inline-block',
          padding:      '3px 8px',
          marginBottom: 8,
        }}
      >
        {name}
      </div>

      {/* Body */}
      <div style={{ fontSize: 7, color: COLOURS.textDark, lineHeight: 2.2 }}>
        {children}
      </div>
    </div>
  );
}

Dialog.propTypes = {
  name:     PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Dialog;
